'use client'

import Image from '@/components/Image'
import type { NotificationListItem } from '@/lib/api/notification'
import { formatNotificationTime } from '@/lib/utils/notification'
import { renderFeedBodyText, renderUnreadDot } from './FeedCardParts'
import { type NotificationVariant, notificationSurfaceCard, notificationText } from './styles'

type Props = {
  variant: NotificationVariant
  item: NotificationListItem
  onClick: () => void
}

function renderMediaThumb(src: string | null) {
  if (!src) return null
  return (
    <span className="size-[calc(56*var(--vw))] shrink-0 overflow-hidden rounded-[calc(12*var(--vw))] bg-[rgba(255,255,255,0.05)]">
      <Image src={src} alt="" width={112} height={112} className="size-full object-cover" />
    </span>
  )
}

export function SystemNotificationCard({ variant, item, onClick }: Props) {
  return (
    <button
      type="button"
      className={`relative flex w-full items-center gap-[calc(12*var(--vw))] ${notificationSurfaceCard(variant)} p-[calc(12*var(--vw))] text-start`}
      onClick={onClick}
    >
      {renderUnreadDot(!item.read)}
      {renderMediaThumb(item.imageUrl)}

      <span className="flex min-w-0 flex-1 flex-col items-start justify-center gap-[calc(4*var(--vw))] overflow-hidden">
        <span className="flex w-full min-w-0 items-start gap-[calc(8*var(--vw))]">
          <span
            className={`min-w-0 flex-1 truncate text-[calc(14*var(--vw))] font-normal leading-[calc(20*var(--vw))] ${notificationText.primary}`}
          >
            {item.title}
          </span>
          <time
            className={`shrink-0 text-[calc(10*var(--vw))] font-normal leading-[calc(14*var(--vw))] ${notificationText.disabled}`}
          >
            {formatNotificationTime(item.createTime)}
          </time>
        </span>
        {renderFeedBodyText(item.body)}
      </span>
    </button>
  )
}
